import { useEffect, useState } from 'react';
import programService from '@/shared/services/programService';
import settingsService from '@/shared/services/settingsService';
import { OTHER_ROLES } from './laAnswers';

/**
 * The page each role in the "also interested" question links to, by role
 * value: a program's page from its settings, tutoring's from the platform
 * settings. A role with no page set, or whose page could not be read, has no
 * entry, and its choice is shown without a link.
 */
export default function useOtherRoleLinks() {
    const [links, setLinks] = useState({});

    useEffect(() => {
        let cancelled = false;
        Promise.all(
            OTHER_ROLES.map(async ({ value, program }) => {
                if (value === 'none') return null;
                try {
                    const url = program
                        ? (await programService.getProgramInfo(program))
                              ?.pageUrl
                        : (await settingsService.getTutoringPage())?.url;
                    return url ? [value, url] : null;
                } catch (_error) {
                    return null;
                }
            })
        ).then((entries) => {
            if (!cancelled) {
                setLinks(Object.fromEntries(entries.filter(Boolean)));
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);

    return links;
}
